/// <reference path="./detectGeo.library.d.ts" />

/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de
 * (Modul: ddetectGeo->detectGeo_Map, detectGeo->detectGeo_Location, detectGeo->detectGeo_Whois)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import jqXHR = JQuery.jqXHR;
import htmlString = JQuery.htmlString;
import {Circle, Icon, LatLngExpression, Marker} from 'leaflet';

/**
 * Interfaces für die PINs
 */
interface pinData {
    infoContent: string,
    markerLayer: Marker,
    circleLayer: Circle
}

interface pinStyle {
    zoomLevel: number,
    radius: number,
    strokeColor: string,
    fillColor: string,
    icon: Icon
}

/**
 * Sonstige Interfaces
 */
interface GeoBogengrad {
    grad: number,
    minuten: number,
    sekunden: number
}

interface GeoPositionInformation {
    strasse: string,
    hausnummer: string,
    plz: string,
    ort: string,
    region: string,
    country: string,
    countrycode: string,
    getPLZOrt(): string,
    getStrasseHausnummer(): string,
    getFlagCountry(): string
}

/**
 * PIN A, B und C definieren
 */
let pinA:pinData = {infoContent: undefined, markerLayer: undefined, circleLayer: undefined};
let pinAstyle:pinStyle = {
    zoomLevel: 9, radius: 30000,
    strokeColor: "rgb(216, 98, 99)", fillColor: "rgba(231, 159, 160, 0.4)",
    icon: L.icon({ iconUrl: "/bundles/deinipcheckbrowserinfo/img/MarkerA.png", iconSize: [46, 46]})
};
let pinB:pinData = {infoContent: undefined, markerLayer: undefined, circleLayer: undefined};
let pinBstyle:pinStyle = {
    zoomLevel: 16, radius: pinAstyle.radius,
    strokeColor: "rgb(252, 128, 15)", fillColor: "rgba(253, 181, 116, 0.4)",
    icon: L.icon({ iconUrl: "/bundles/deinipcheckbrowserinfo/img/MarkerB.png", iconSize: [46, 46]})
};
let pinC:pinData = {infoContent: undefined, markerLayer: undefined, circleLayer: undefined};
let pinCstyle:pinStyle = { zoomLevel: 16, radius: -1,
    strokeColor: "rgb(84, 136, 251)", fillColor: "rgba(184, 205, 253, 0.4)",
    icon: L.icon({ iconUrl: "/bundles/deinipcheckbrowserinfo/img/MarkerC.png", iconSize: [46, 46]})
};

// MAP-Variable
export let karte: any;

/**
 * Klasse für alle Map-basierenden Methoden
 */
export class detectGeo_Map {
    public static initMap() {
        // Karte initialisieren
        karte = L.map('map').fitWorld();
        
        L.tileLayer('//maps.dein-ip-check.de/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.de">OpenStreetMap</a> - Mitwirkende'
        }).addTo(karte);
        
        karte.attributionControl.setPrefix(false);
        karte.scrollWheelZoom.disable();
        L.control.scale().addTo(karte);

        //Reagiere auf Click-Handler
        $('#pinA').on("click", function(){
            karte.fitBounds( pinA.circleLayer.getBounds() );
        });
        $('#pinB').on("click",function(){
            karte.fitBounds( pinB.circleLayer.getBounds() );
        });
        $('#pinC').on("click",function(){
            karte.fitBounds( pinC.circleLayer.getBounds() );
        });
    }

    // noinspection DuplicatedCode
    /**
     * Hilfsfunktion: Setze PIN und Kreis auf Google Maps
     *
     * @param markerName
     * @param latitude
     * @param longitude
     * @param radius
     * @param strokeColor
     * @param fillColor
     * @param icon
     * @param infoContent
     * @returns object
     */
    public static updateOpenStreetMaps(
        markerName:string,
        latitude:string, longitude:string, radius:number,
        strokeColor:string, fillColor:string, icon:Icon,
        infoContent:string
    ):pinData {
        // Position von String in Float-Wert umwandeln
        let latLon:LatLngExpression = {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        } 
        
        // Marker hinzufügen
        let marker_MarkerLayer = L.marker(latLon, {icon: icon}).addTo(karte);
        
        let marker_CircleLayer = L.circle([parseFloat(latitude), parseFloat(longitude)],radius, {
            color: strokeColor,
            fillColor: fillColor,
            fillOpacity: 0.5
        }).addTo(karte);
        
        //if(panToMarker) {
            //karte.fitBounds( marker_CircleLayer.getBounds() );
        //}

        // Popup definieren
        marker_MarkerLayer.bindPopup(infoContent);
        marker_CircleLayer.bindPopup(infoContent);

        // Button freigeben        
        $("#" + markerName).prop("disabled", false).show();
        
        return {infoContent: null, markerLayer: marker_MarkerLayer, circleLayer: marker_CircleLayer};
    }
}

/**
 * Klasse für alle Location-based Funktionen
 */
export class detectGeo_Location {
    /**
     * Aktualisiere IPv4-Adresse
     */
    public static updateIPv4() {
        if(initLatitude !== 'undefined' && initLongitude !== 'undefined' && isIPv6 === "0") {
            //
            // Daten wurden bereits vom Backend übergeben
            //
            // noinspection JSNonASCIINames
            let content = `<div id='markerContent'>
                <div id='siteNotice'></div>
                    <h4 id='firstHeading' class='firstHeading'>${DETECTPHRASE["Position anhand der"]} IPv4-${DETECTPHRASE["Adresse"]}:</h4>
                    <div id='bodyContent'>
                        <b>${DETECTPHRASE["Genauigkeit"]}:</b> ${$("#ipv4geogenauigkeit").html()}<br /><br />
                        <b>${DETECTPHRASE["Land"]}:</b> ${$("#ipv4geocountry").html()}<br />
                        <b>${DETECTPHRASE["Region"]}:</b> ${$("#ipv4georegion").html()}<br />
                        <b>${DETECTPHRASE["Ort"]}:</b> ${$("#ipv4geocity").html()}<br /><br />
                        <b>${DETECTPHRASE["Breitengrad"]}:</b> ${$("#ipv4geolatitude").html()}<br />
                        <b>${DETECTPHRASE["Längengrad"]}:</b> ${$("#ipv4geolongitude").html()}<br />
                    </div>
                </div>
            `;

            pinA = detectGeo_Map.updateOpenStreetMaps(
                "pinA",
                initLatitude, initLongitude,
                parseInt(initAccuracy)*1000, pinAstyle.strokeColor,
                pinAstyle.fillColor, pinAstyle.icon, content
            );

            // Clipboard und Whois aktivieren (Adresse neu setzen um Bug in Safari zu umgehen)
            let ip4AdressElement = $("#ipv4addresse");
            ip4AdressElement.prop("disabled", false)
            ip4AdressElement.val( String(ip4AdressElement.val() + " ") );
            ip4AdressElement.val( String(ip4AdressElement.val()).slice(0, -1) );
            $(`#ipv4clipboard`).prop( "disabled", false );
            $("#ipv4whois").prop("disabled", false);

            // auf PIN A zoomen
            karte.fitBounds( pinA.circleLayer.getBounds() );
        } else {
            //
            //  Daten via AJAX auslesen
            //
            try {
                let ipv4test: jqXHR<any>;
                ipv4test = $.ajax({
                    url: `https://ipv4-test.dein-ip-check.de/ajax/v3/ip?lang=${DETECTLANGUAGE}`,
                    dataType: "json",
                    timeout: 3000
                })
                    .done(function () {
                        if (ipv4test.responseJSON.status === "OK") {
                            // ASN für IPv4 und IPv6 setzen und Tunnel auswerten
                            let ipv4asn = ipv4test.responseJSON.asn;
                            if (typeof initAsn === 'undefined') {
                                console.warn("initAsn-Variable nicht gesetzt - gehe von einem nativen Anschluss aus");
                                initAsn = "0";
                            }

                            // Testergebnis auswerten
                            $("#ipv4addresse").prop("disabled", false).val(ipv4test.responseJSON.ip);
                            $("#ipv4hostname").html(ipv4test.responseJSON.hostname.replace('.', '.<wbr/>'));
                            $("#ipv4provider").html(ipv4test.responseJSON.provider);
                            $("#ipv4providerorg").html(ipv4test.responseJSON.providerorg);

                            if(ipv4test.responseJSON.ipv4dynip === true) {
                                $("#ipv4dyndns").html(`Dyn.IP: ${DETECTPHRASE["aktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-success");
                            } else {
                                $("#ipv4dyndns").html(`Dyn.IP: ${DETECTPHRASE["inaktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-danger");
                            }
                            if(ipv4test.responseJSON.tor === true) {
                                $("#ipv4tor").html(`Tor: ${DETECTPHRASE["aktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-success");
                            } else {
                                $("#ipv4tor").html(`Tor: ${DETECTPHRASE["inaktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-danger");
                            }
                            if(ipv4test.responseJSON.ipv4proxy === true) {
                                $("#ipv4proxy").html(`Proxy: ${DETECTPHRASE["aktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-success");
                            } else {
                                $("#ipv4proxy").html(`Proxy: ${DETECTPHRASE["inaktiv"]}`)
                                    .removeClass("label-info")
                                    .addClass("label-danger");
                            }

                            // Überschreibe den Tunnel-Test
                            if (initAsn === ipv4asn) {
                                // Definitiv KEIN Tunnel erkannt (kein bekannter Tunnelbroker + gleiches ASN)
                                $("#ipv6native").html(DETECTPHRASE["Natives IPv6"] + ": " + DETECTPHRASE["aktiv"])
                                    .removeClass("label-info")
                                    .removeClass("label-warning")
                                    .addClass("label-success");
                                $("#ipv6tunnel").html(DETECTPHRASE["Natives IPv6"] + ": " + DETECTPHRASE["nicht in Verwendung"])
                                    .removeClass("label-info")
                                    .removeClass("label-warning")
                                    .addClass("label-success");
                            }

                            // Clipboard und Whois aktivieren
                            $(`#ipv4clipboard`).prop( "disabled", false );
                            $("#ipv4whois").prop("disabled", false);
                        } else if (ipv4test.responseJSON.status === "AUTH") {
                            // noinspection JSNonASCIINames
                            $("#ipv4addresse").val(`IPv4-${DETECTPHRASE["Ermittlung wurde nicht durchgeführt"]}`);
                            $("#ipv4hostname").text("-");
                            $("#ipv4provider").text("-");
                            $("#ipv4providerorg").text("-");
                            $(`#ipv4clipboard`).prop( "disabled", true );
                            $("#ipv4whois").prop("disabled", true);
                        } else {
                            $("#ipv4addresse").val(`IPv4 ${DETECTPHRASE["nicht vorhanden"]}`);
                            $("#ipv4hostname").text("-");
                            $("#ipv4provider").text("-");
                            $("#ipv4providerorg").text("-");
                            $(`#ipv4clipboard`).prop( "disabled", true );
                            $("#ipv4whois").prop("disabled", true);
                        }
                    })
                    .fail(function () {
                        $("#ipv4addresse").val(`IPv4 ${DETECTPHRASE["nicht vorhanden"]}`);
                        $("#ipv4hostname").text("-");
                        $("#ipv4provider").text("-");
                        $("#ipv4providerorg").text("-");
                        $(`#ipv4clipboard`).prop( "disabled", true );
                        $("#ipv4whois").prop("disabled", true);
                    });
            } catch (err) {
                $("#ipv4addresse").val(`${DETECTPHRASE["Fehler beim ermitteln der"]} IPv4 ${DETECTPHRASE["Adresse"]}`);
                $("#ipv4hostname").text("-");
                $("#ipv4provider").text("-");
                $("#ipv4providerorg").text("-");
                $(`#ipv4clipboard`).prop( "disabled", true );
                $("#ipv4whois").prop("disabled", true);
            }

            // City-Informationen ermitteln
            detectGeo_Location.getCityInformation("ipv4", false);
        }
    }    

    /**
     * Aktualisiere IPv6-Adresse
     */
    public static updateIPv6() {
        if(initLatitude !== 'undefined' && initLongitude !== 'undefined' && isIPv6 === "1") {
            //
            // Daten wurden bereits vom Backend übergeben
            //
            // noinspection JSNonASCIINames
            let content = `<div id='markerContent'>
                <div id='siteNotice'></div>
                    <h4 id='firstHeading' class='firstHeading'>${DETECTPHRASE["Position anhand der"]} IPv6-${DETECTPHRASE["Adresse"]}:</h4>
                    <div id='bodyContent'>
                        <b>${DETECTPHRASE["Genauigkeit"]}:</b> ${$("#ipv6geogenauigkeit").html()}<br /><br />
                        <b>${DETECTPHRASE["Land"]}:</b> ${$("#ipv6geocountry").html()}<br />
                        <b>${DETECTPHRASE["Region"]}:</b> ${$("#ipv6georegion").html()}<br />
                        <b>${DETECTPHRASE["Ort"]}:</b> ${$("#ipv6geocity").html()}<br /><br />
                        <b>${DETECTPHRASE["Breitengrad"]}:</b> ${$("#ipv6geolatitude").html()}<br />
                        <b>${DETECTPHRASE["Längengrad"]}:</b> ${$("#ipv6geolongitude").html()}<br />
                    </div>
                </div>
            `;
            
            pinB = detectGeo_Map.updateOpenStreetMaps(
                "pinB",
                initLatitude, initLongitude,
                parseInt(initAccuracy)*1000, pinBstyle.strokeColor,
                pinBstyle.fillColor, pinBstyle.icon, content
            );
            
            // Clipboard und Whois aktivieren (Adresse neu setzen um Bug in Safari zu umgehen)
            let ip6AdressElement = $("#ipv6addresse");
            ip6AdressElement.prop("disabled", false)
            ip6AdressElement.val( String(ip6AdressElement.val() + " ") );
            ip6AdressElement.val( String(ip6AdressElement.val()).slice(0, -1) );
            ip6AdressElement.prop("disabled", false);
            $(`#ipv6clipboard`).prop( "disabled", false );
            $("#ipv6whois").prop("disabled", false);

            // auf PIN B zoomen
            karte.fitBounds( pinB.circleLayer.getBounds() );
        } else {
            //
            //  Daten via AJAX auslesen
            //
            try {
                let ipv6test: jqXHR<any>;
                let tunnel = false;

                ipv6test = $.ajax({
                    url: `https://ipv6-test.dein-ip-check.de/ajax/v3/ip?lang=${DETECTLANGUAGE}`,
                    dataType: "json",
                    timeout: 3000
                }).done(function () {
                    if (ipv6test.responseJSON.status === "OK") {
                        // Clipboard und Whois aktivieren (Adresse neu setzen um Bug in Safari zu umgehen)
                        $("#ipv6addresse").prop("disabled", false).val(ipv6test.responseJSON.ip);
                        $("#ipv6hostname").html(ipv6test.responseJSON.hostname.replace('.', '.<wbr/>'));
                        $("#ipv6provider").html(ipv6test.responseJSON.provider);
                        $("#ipv6providerorg").html(ipv6test.responseJSON.providerorg);

                        // ASN für IPv4 und IPv6 setzen und Tunnel auswerten
                        let ipv6asn = ipv6test.responseJSON.asn;
                        if (typeof initAsn === 'undefined') {
                            console.warn("initAsn-Variable nicht gesetzt - nutze Fallback auf Provider-Name für IPv4 ASN");
                            initAsn = $("#ipv4provider").html();
                        }

                        // Tor aktiv?
                        if (ipv6test.responseJSON["tor"] === true) {
                            $("#ipv6tor").html(
                                `Tor: ${DETECTPHRASE['aktiv']}`
                            )
                                .removeClass("label-info")
                                .addClass("label-success");
                        } else if (ipv6test.responseJSON["tor"] === false) {
                            $("#ipv6tor").html(
                                `Tor: ${DETECTPHRASE['inaktiv']}`
                            )
                                .removeClass("label-info")
                                .addClass("label-danger");
                        } else {
                            $("#ipv6tor").html(
                                `Tor: ${DETECTPHRASE['keine']} ${DETECTPHRASE['Informationen']}`
                            )
                                .removeClass("label-info")
                                .addClass("label-warning");
                        }

                        // Prüfe ob nativer Zugang oder nicht
                        if (ipv6test.responseJSON["tunnel"] === false 
                            && ipv6test.responseJSON["teredo"] === false
                            && ipv6test.responseJSON["6to4"] === false
                            && ipv6asn === initAsn
                        ) {
                            // Definitiv KEIN Tunnel erkannt (kein bekannter Tunnelbroker + gleiches ASN)
                            $("#ipv6native").html(DETECTPHRASE["Natives IPv6"] + ": " + DETECTPHRASE["aktiv"])
                                .removeClass("label-info")
                                .addClass("label-success");
                            tunnel = false;
                        } else if (ipv6test.responseJSON["tunnel"] === false
                            && ipv6test.responseJSON["teredo"] === false
                            && ipv6test.responseJSON["6to4"] === false
                            && ipv6asn !== initAsn
                        ) {
                            // Nativer-Zugang mit unterschiedlicher ASN  !!! PHRASE FEHLT!
                            $("#ipv6native").html(DETECTPHRASE["Natives IPv6"] + ": " + DETECTPHRASE["(wahrscheinlich) aktiv"])
                                .removeClass("label-info")
                                .addClass("label-success");
                            tunnel = false;
                        } else {
                            // Kein Nativer Zugang
                            $("#ipv6native").html(DETECTPHRASE["Natives IPv6"] + ": " + DETECTPHRASE["inaktiv"])
                                .removeClass("label-info")
                                .addClass("label-warning");
                            tunnel = true;
                        }
                                          
                        // Art des Tunnels herausfinden
                        if (tunnel === true && ipv6test.responseJSON["teredo"] === true) {
                            // Tunnel und Tunnel-Typ Teredo erkannt
                            $("#ipv6tunnel").html("Via Teredo Tunnel")
                                .removeClass("label-info")
                                .addClass("label-warning");
                        } else if (tunnel === true && ipv6test.responseJSON["6to4"] === true) {
                            // Tunnel und Tunnel-Typ 6to4 erkannt
                            $("#ipv6tunnel").html("Via 6to4 Tunnel")
                                .removeClass("label-info")
                                .addClass("label-warning");
                        } else if (tunnel === true && ipv6test.responseJSON["tunnel"] === true) {
                            // Tunnel und bekannten Tunnelbroker
                            $("#ipv6tunnel").html("Via Tunnelbroker")
                                .removeClass("label-info")
                                .addClass("label-warning");
                        } else if (tunnel === true) {
                            // Tunnel und unbekannten Tunnelbroker (Fallback)
                            $("#ipv6tunnel").html("Via Tunnel")
                                .removeClass("label-info")
                                .addClass("label-warning");
                        } else {
                            // kein Tunnelbroker vorhanden
                            $("#ipv6tunnel").html("nicht in Verwendung")
                                .removeClass("label-info")
                                .addClass("label-success");
                        }

                        $(`#ipv6clipboard`).prop( "disabled", false );
                        $("#ipv6whois").prop("disabled", false);
                    } else if (ipv6test.responseJSON.status === "AUTH") {
                        // noinspection JSNonASCIINames
                        $("#ipv6addresse").val(`IPv6-${DETECTPHRASE["Ermittlung wurde nicht durchgeführt"]}`);
                        $("#ipv6hostname").text("-");
                        $("#ipv6provider").text("-");
                        $("#ipv6providerorg").text("-");
                        $("#ipv6tunnel").text(DETECTPHRASE["keine Informationen"])
                            .removeClass("label-default").addClass("label-info");
                        $(`#ipv6clipboard`).prop( "disabled", true );
                        $("#ipv6whois").prop("disabled", true);
                    } else {
                        $("#ipv6addresse").val("IPv6 " + DETECTPHRASE["nicht vorhanden"]);
                        $("#ipv6hostname").text("-");
                        $("#ipv6provider").text("-");
                        $("#ipv6providerorg").text("-");
                        $("#ipv6tunnel").text(DETECTPHRASE["keine Informationen"])
                            .removeClass("label-default").addClass("label-info");
                        $(`#ipv6clipboard`).prop( "disabled", true );
                        $("#ipv6whois").prop("disabled", true);
                    }

                    // Aktualisiere IPv6-Geo Informationen
                    detectGeo_Location.getCityInformation("ipv6", tunnel);
                }).fail(function () {
                    console.warn("IPv6-Testsystem kann durch den Besucher nicht erreicht werden");
                    $("#ipv6addresse").val(`IPv6 ${DETECTPHRASE["nicht vorhanden"]}`);
                    $("#ipv6hostname").text("-");
                    $("#ipv6provider").text("-");
                    $("#ipv6providerorg").text("-");
                    $("#ipv6tunnel").text(DETECTPHRASE["keine Informationen"])
                        .removeClass("label-default").addClass("label-info");
                    $(`#ipv6clipboard`).prop( "disabled", true );
                    $("#ipv6whois").prop("disabled", true);
                    $("#ipv6info").css("opacity", 0.3);
                    // noinspection JSNonASCIINames
                    $("#ipv6geo").css("opacity", 0.3)
                        .find("table")
                        .replaceWith(`<p>IPv6-${DETECTPHRASE["Zugang steht nicht zur Verfügung"]}.</p>`);
                });
            } catch (err) {
                console.warn("Fehler beim Zugriff auf das IPv6-Testsystem");
                $("#ipv6addresse").val(`${DETECTPHRASE["Fehler beim ermitteln der"]} IPv6 ${DETECTPHRASE["Adresse"]}`);
                $("#ipv6hostname").text("-");
                $("#ipv6provider").text("-");
                $("#ipv6providerorg").text("-");
                $("#ipv6tunnel").text(DETECTPHRASE["keine Informationen"])
                    .removeClass("label-default").addClass("label-info");
                $(`#ipv6clipboard`).prop( "disabled", true );
                $("#ipv6whois").prop("disabled", true);
                $("#ipv6info").css("opacity", 0.3);
                $("#ipv6geo").css("opacity", 0.3)
                    .find("table")
                    .replaceWith(`<p>${DETECTPHRASE["Ermittlung der Informationen ist fehlgeschlagen"]}.</p>`);
            }
        }
    }

    /**
     * Ermitteln der aktuellen Position via Javascript-Schnittstelle
     * @param position
     */
    public static showGeoPosition(position: GeolocationPosition) {
        let longitude = position.coords.longitude,
            latitude = position.coords.latitude,
            accuracy = position.coords.accuracy,
            accuracyEinheit = "Meter",
            altitude = position.coords.altitude,
            altitudeEinheit = "Meter",
            heading = position.coords.heading,
            speed = position.coords.speed;

        let browserGeoInfoMessage = $("#browserGeoInfoMessage");

        // Bisheriger Marker löschen
        if(typeof pinC.markerLayer !== "undefined") {
            console.info("Setze pinC Marker zurück!");
            pinC.markerLayer.removeFrom(karte);
            pinC.circleLayer.removeFrom(karte);
        }

        // Longitude/Latitude um Himmelsrichtung erweitern
        let bogLatitude:string, bogLongitude:string;
        if(latitude < 0) {
            // noinspection JSNonASCIINames
            bogLatitude = `${detectGeo_Location.convertDecToBogenmass(latitude)} ${DETECTPHRASE["Süd"]}`;
        } else {
            bogLatitude = `${detectGeo_Location.convertDecToBogenmass(latitude)} ${DETECTPHRASE["Nord"]}`;
        }
        if(longitude < 0) {
            bogLongitude = `${detectGeo_Location.convertDecToBogenmass(longitude)} ${DETECTPHRASE["West"]}`;
        } else {
            bogLongitude = `${detectGeo_Location.convertDecToBogenmass(longitude)} ${DETECTPHRASE["Ost"]}`;
        }

        //
        // Die direkt ermittelten Werte in Tabelle ausgeben
        //

        // Koordinaten
        $("#GeoLocationLaengengrad").show().find("> td > span").html(bogLongitude);
        $("#GeoLocationBreitengrad").show().find("> td > span").html(bogLatitude);

        // Update-Zeitstempel (mit IE10-Fallback)
        let langCode: string;
        if(DETECTLANGUAGE === 'de') {
            langCode = "de-DE";
        } else {
            langCode = "en-US";
        }
        let currentTime = new Date();

        $("#GeoLocationTimestamp").show().find("> td > span")
            .html(
                `${currentTime.toLocaleDateString(langCode)} ${currentTime.toLocaleTimeString(langCode)}`
            );

        // Genauigkeit
        let strAccuracy:string;
        if(accuracy !== null) {
            if(accuracy > 5000) {
                strAccuracy =(accuracy/1000).toFixed(2);
                accuracyEinheit = " km";
            } else {
                strAccuracy = accuracy.toFixed(0);
                accuracyEinheit = " Meter";
            }

            $("#GeoLocationGenauigkeit").show().find('> td > span').html(`~${strAccuracy} ${accuracyEinheit}`);
        } else {
            $("#GeoLocationGenauigkeit").hide().find("> td > span").html(DETECTPHRASE["unbekannt"]);
            strAccuracy = "unbekannt";
            accuracyEinheit = "";
        }

        // Richtung
        if(heading !== null && heading > 0) {
            $("#GeoLocationRichtung").show().find('> td > span').html(heading.toFixed(0) + "&#176;");
        } else {
            $("#GeoLocationRichtung").hide().find("> td > span").html(DETECTPHRASE["unbekannt"]);
        }

        // Geschwindigkeit
        if(speed !== null && speed > 0) {
            speed = (speed * 3600) / 1000;
            $('#GeoLocationGeschwindigkeit').show().find('> td > span').html(`${speed.toFixed(2)} km/h`);
        } else {
            $("#GeoLocationGeschwindigkeit").hide().find("> td > span").html(DETECTPHRASE["unbekannt"]);
        }

        // Höhe
        if(altitude !== null && altitude > 0) {
            let strAltitude;
            if(altitude>1000) {
                altitude = (altitude/1000);
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') {
                    strAltitude = altitude.toLocaleString(langCode,{ minimumFractionDigits: 2, maximumFractionDigits: 2 } );
                } else {
                    strAltitude = altitude.toFixed(2).toString();
                }
                altitudeEinheit = " km";
            } else {
                if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') {
                    strAltitude = altitude.toLocaleString(langCode, { maximumFractionDigits: 0 } );
                } else {
                    strAltitude = altitude.toFixed(0).toString();
                }
                altitudeEinheit = " Meter";
            }
            $('#GeoLocationHoehe').show().find('> td > span').html(`${strAltitude} ${altitudeEinheit}`);
        } else {
            $("#GeoLocationHoehe").hide().find("> td > span").html(DETECTPHRASE["unbekannt"]);
        }

        // Ortsdaten anhand der Position bestimmen
        const latlng = {latitude: position.coords.latitude, longitude: position.coords.longitude};

        browserGeoInfoMessage.html(`<div id="browserGeoAlert" class="alert-success alert">
            <button type="button" class="close" data-dismiss="alert">×</button> ${DETECTPHRASE["Ermittle Address-Daten anhand der Position"]}.
            </div>`
        );

        /*
         * Ermittle mittels AJAX die zu den Koordinaten passenden Ort
         * (Reverse Geocode)
         */
        try {
            let geocode:jqXHR<any>;
            let address: GeoPositionInformation = {
                strasse: "",
                hausnummer: "",
                plz: "",
                ort: "",
                region: "",
                country: "",
                countrycode: "",
                getPLZOrt: function (): string {
                    if (this.plz !== "" && this.ort !== "") {
                        return this.plz + " " + this.ort;
                    } else if (this.ort !== "") {
                        return this.ort;
                    } else {
                        return "";
                    }
                },
                getStrasseHausnummer: function (): string {
                    if (this.strasse !== "" && this.hausnummer !== "") {
                        return this.strasse + " " + this.hausnummer;
                    } else if (this.strasse !== "") {
                        return this.strasse;
                    } else {
                        return "";
                    }
                },
                getFlagCountry: function (): htmlString {
                    if (this.countrycode !== "" && this.country !== "") {
                        return `<img style='padding-right: 5px' src='/bundles/deinipcheckbrowserinfo/img/${this.countrycode}.png' alt='${this.countrycode}' /> ${this.country}`;
                    } else if (this.country !== "") {
                        return this.country;
                    } else {
                        return "";
                    }
                }
            };

            geocode = $.ajax({
                type: "POST",
                url: `https://ipv4-test.dein-ip-check.de/ajax/v2/geocode?lang=${DETECTLANGUAGE}`,
                data: latlng,
                dataType: "json",
                timeout: 3000
            }).done(function () {
                // AJAX Abfrage wurde erfolgreich durchgeführt
                let geoCodeResults = geocode.responseJSON.geocode.address;

                // Antwort auswerten
                if(geocode.responseJSON.status === "OK" && typeof geocode.responseJSON.geocode === "object") {
                    // Location-Object zusammenstellen
                    address.strasse = (typeof geoCodeResults.road !== "undefined" ?  geoCodeResults.road : "");
                    address.hausnummer  = (typeof geoCodeResults.house_number !== "undefined" ? geoCodeResults.house_number :  "");
                    address.country = (typeof geoCodeResults.country !== "undefined" ? geoCodeResults.country : "");
                    address.countrycode = (typeof geoCodeResults.country_code !== "undefined" ? geoCodeResults.country_code : "");
                    address.region = (typeof geoCodeResults.state !== "undefined" ? address.region = geoCodeResults.state : "");
                    address.plz  = (typeof geoCodeResults.postcode !== "undefined" ? geoCodeResults.postcode : "");
                    if(typeof geoCodeResults.village !== "undefined") {
                        address.ort = geoCodeResults.village;
                    } else if(typeof geoCodeResults.city !== "undefined") {
                        address.ort = geoCodeResults.city;
                    } else {
                        address.ort = "";
                    }
                    if(typeof geoCodeResults.suburb !== "undefined") {
                        address.ort = `${address.ort} (${geoCodeResults.suburb})`;
                    }

                    // Nicht benötigte Elemente ausblenden
                    if (address.getFlagCountry() !== "") {
                        $("#GeoLocationLand").show().find('> td > span').html(address.getFlagCountry());
                    } else {
                        $("#GeoLocationLand").hide().find('> td > span').html(DETECTPHRASE["unbekannt"]);
                    }

                    if(address.region) {
                        $("#GeoLocationRegion").show().find('> td > span').html(address.region);
                    } else {
                        $("#GeoLocationRegion").hide().find('> td > span').html(DETECTPHRASE["unbekannt"]);
                    }

                    if(address.getPLZOrt()) {
                        $("#GeoLocationOrt").show().find('> td > span').html(address.getPLZOrt());
                    } else {
                        $("#GeoLocationOrt").hide().find('> td > span').html(DETECTPHRASE["unbekannt"]);

                    }

                    if(address.getStrasseHausnummer()) {
                        $("#GeoLocationStrasse").show().find('> td > span').html(address.getStrasseHausnummer());
                    } else {
                        $("#GeoLocationStrasse").hide().find('> td > span').html(DETECTPHRASE["unbekannt"]);
                    }

                    // Alert schließen, Info-Feld ausblenden und Button freigeben
                    $("#refreshPosition").removeClass('disabled').html(DETECTPHRASE["Aktualisieren"]);
                    browserGeoInfoMessage.hide().find("> div").alert("close");

                    // noinspection JSNonASCIINames
                    let infoContent = `<div id='markerContent'>
                        <div id='siteNotice'></div>
                            <h4 id='firstHeading' class='firstHeading'>${DETECTPHRASE["Position über Browser"]}</h4>
                            <div id='bodyContent'>
                                <b>${DETECTPHRASE["Genauigkeit"]}:</b> ${strAccuracy} ${accuracyEinheit}<br /><br />` +
                        (address.getStrasseHausnummer() !== "" ?  `<b>${DETECTPHRASE["Straße"]}:</b> ${address.getStrasseHausnummer()}<br />`: "") +
                        (address.getPLZOrt() !== "" ? `<b>${DETECTPHRASE["Ort"]}:</b> ${address.getPLZOrt()}<br />` : "") +
                        (address.region !== "" ? `<b>${DETECTPHRASE["Region"]}:</b> ${address.region}<br />` : "") +
                        (address.getFlagCountry() !== "" ? `<b>${DETECTPHRASE["Land"]}:</b> ${address.getFlagCountry()}<br /><br />` : "") +
                        `<b>${DETECTPHRASE["Breitengrad"]}:</b> ${bogLatitude}<br />
                                <b>${DETECTPHRASE["Längengrad"]}:</b> ${bogLongitude}<br />
                            </div>
                        </div>
                    </div>`;

                    // PIN C setzen
                    if(typeof pinC.markerLayer !== "undefined") {
                        // PINs zurücksetzen
                        karte.removeLayer(pinC.markerLayer);
                        karte.removeLayer(pinC.circleLayer);
                    }

                    pinC = detectGeo_Map.updateOpenStreetMaps(
                        "pinC",
                        position.coords.latitude.toString(),
                        position.coords.longitude.toString(),
                        position.coords.accuracy,
                        pinCstyle.strokeColor,
                        pinCstyle.fillColor,
                        pinCstyle.icon,
                        infoContent
                    );

                    // auf PIN C zoomen
                    karte.fitBounds( pinC.circleLayer.getBounds() );
                } else {
                    // Abfrage der Ortsdaten fehlgeschlagen
                    browserGeoInfoMessage.html(
                        `<div id="browserGeoAlert" class="alert-warning alert"><button type="button" class="close" data-dismiss="alert">×</button> ${DETECTPHRASE["Ermittlung der Adresse fehlgeschlagen"]}.</div>`
                    );
                }

            }).fail(function () {
                // Fehler beim Reverse-Geocoding des AJAX Request
                let errorText = "Fehler beim AJAX-Request für Reverse-Geocoding anhand der Positions-Daten des Browsers";
                browserGeoInfoMessage.html(
                    `<div id="browserGeoAlert" class="alert-danger alert"><a class="close" data-dismiss="alert">×</a><span>${errorText}</span></div>`
                );
            });
        } catch (err) {
            // Unbekannter Fehler beim AJAX Request
            let errorText = "Unbekannter Fehler beim Reverse-Geocoding anhand der Positions-Daten des Browsers";
            browserGeoInfoMessage.html(
                `<div id="browserGeoAlert" class="alert-danger alert"><a class="close" data-dismiss="alert">×</a><span>${errorText}</span></div>`
            );
        }
    }

    /**
     * Fehler beim ermitteln der Location via Javascript-Schnittstelle
     * @param error
     */
    public static showGeoError(error:GeolocationPositionError) {
        $("#browserGeoAlert").alert("close");
        $("#refreshPosition").show();

        let errorText = `<b>${DETECTPHRASE["Positionsbestimmung ist fehlgeschlagen"]}:</b><br />`;
        switch (error.code) {
            case error.PERMISSION_DENIED:
                // noinspection JSNonASCIINames
                errorText += DETECTPHRASE["Die GeoLocation Unterstützung wurde gesperrt"];
                break;
            case error.POSITION_UNAVAILABLE:
                // noinspection JSNonASCIINames
                errorText += DETECTPHRASE["GeoLocation Information steht nicht zur Verfügung"];
                break;
            case error.TIMEOUT:
                // noinspection JSNonASCIINames
                errorText += DETECTPHRASE["GeoLocation-Abfrage führte zur Zeitüberschreitung"];
                break;
            default:
                errorText += DETECTPHRASE["Unbekannter Fehler"];
                break;
        }

        // Fehlermeldung ausgeben
        $("#browserGeoInfoMessage").html(
            `<div id="browserGeoAlert" class="alert-danger alert"><a class="close" data-dismiss="alert">×</a><span>${errorText}</span></div>`
        );
    }

    /**
     * Aktualisiere City-Informationen anhand der ermittelten IP-Adresse
     *
     * @param protokoll
     * @param tunnel
     */
    private static getCityInformation(protokoll: string, tunnel: boolean) {
        try {
            let iptcity: jqXHR<any>;

            iptcity = $.ajax({
                url: `https://${protokoll}-test.dein-ip-check.de/ajax/v2/city?lang=${DETECTLANGUAGE}`,
                dataType: "json",
                timeout: 3000
            }).done(function () {
                if (iptcity.responseJSON.status === "OK") {
                    /*
                     * Benötigte Informationen umsetzen
                     */
                    const imgFlag = `<img src='/bundles/deinipcheckbrowserinfo/img/${iptcity.responseJSON.country_code.toLowerCase()}.png' alt='${iptcity.responseJSON.country_name}' />`;

                    let city, continent, latitude, longitude;
                    if (iptcity.responseJSON.postal_code !== "" && iptcity.responseJSON.postal_code !== "n/a") {
                        city = `${iptcity.responseJSON.postal_code} ${iptcity.responseJSON.city}`;
                    } else {
                        city = iptcity.responseJSON.city;
                    }

                    if (iptcity.responseJSON.postal_code !== "" && iptcity.responseJSON.postal_code !== "n/a") {
                        continent = ` (${iptcity.responseJSON.continent_name})`;
                    } else {
                        continent = "";
                    }

                    if (iptcity.responseJSON.latitude !== "" && iptcity.responseJSON.latitude !== "n/a") {
                        if (iptcity.responseJSON.latitude < 0) {
                            // noinspection JSNonASCIINames
                            latitude = `${detectGeo_Location.convertDecToBogenmass(iptcity.responseJSON.latitude)} ${DETECTPHRASE["Süd"]}`;
                        } else {
                            latitude = `${detectGeo_Location.convertDecToBogenmass(iptcity.responseJSON.latitude)} ${DETECTPHRASE["Nord"]}`;
                        }
                    } else {
                        latitude = "-";
                    }

                    if (iptcity.responseJSON.longitude !== "" && iptcity.responseJSON.longitude !== "n/a") {
                        if (iptcity.responseJSON.longitude < 0) {
                            longitude = `${detectGeo_Location.convertDecToBogenmass(iptcity.responseJSON.longitude)} ${DETECTPHRASE["West"]}`;
                        } else {
                            longitude = `${detectGeo_Location.convertDecToBogenmass(iptcity.responseJSON.longitude)} ${DETECTPHRASE["Ost"]}`;
                        }
                    } else {
                        longitude = "-";
                    }

                    // Genauigkeit ermitteln
                    let accuracyEinheit:string, strAccuracy:string;
                    let accuracy:number;

                    if(iptcity.responseJSON.radius !== "" && iptcity.responseJSON.radius) {
                        // Quelle für die Genauigkeit ist die GeoIP-DB (Orginal-Wert ist im Meter)
                        accuracy = parseInt(iptcity.responseJSON.radius) * 1000;
                    } else {
                        // QUelle für die Genauigkeit ist ein fester Wert
                        protokoll === "ipv4" ? accuracy = pinAstyle.radius : accuracy = pinBstyle.radius;
                    }

                    if(accuracy > 5000) {
                        // Ergebnis in "Meter" ausgeben
                        strAccuracy = (accuracy/1000).toFixed(0);
                        accuracyEinheit = " km";
                    } else {
                        // Ergebnis in "Kilometer" ausgeben
                        strAccuracy = accuracy.toFixed(0);
                        accuracyEinheit = " Meter";
                    }

                    // Felder ausfüllen
                    $("#" + protokoll + "geocountry").html( `${imgFlag}&nbsp;${iptcity.responseJSON.country_name}${continent}` );
                    $("#" + protokoll + "georegion").text( iptcity.responseJSON.region );
                    $("#" + protokoll + "geocity").text( city );

                    $("#" + protokoll + "geolatitude").html( latitude );
                    $("#" + protokoll + "geolongitude").html( longitude );
                    $("#" + protokoll + "geogenauigkeit").html( strAccuracy + accuracyEinheit );

                    // Tunnel-Warnung notwendig?
                    let markerHinweis;
                    if(tunnel === true) {
                        markerHinweis = "<br /> <span style=\"color: #d34e4f\"><strong>Hinweis:</strong> "
                            + DETECTPHRASE["Position des IPv6-Tunnel Endpunkt"]
                            + "</span>";
                        $("#ipv6geohinweis").show().css("color", "#d34e4f")
                            .find("> td > span")
                            .text(DETECTPHRASE["Position des IPv6-Tunnel Endpunkt"])
                    } else {
                        markerHinweis = "";
                    }

                    //Google Maps Pointer setzen
                    if(iptcity.responseJSON.latitude !== "" && iptcity.responseJSON.latitude !== "n/a") {
                        // Content zusammenstellen
                        let content:htmlString;

                        // noinspection JSNonASCIINames
                        content = `<div id='markerContent'>
                            <div id='siteNotice'></div>
                                <h4 id='firstHeading' class='firstHeading'>
                                    ${DETECTPHRASE["Position anhand der"]} ` +
                            (protokoll === "ipv4" ? "IPv4" : "IPv6") +
                            `${DETECTPHRASE["Adresse"]}:
                                </h4>
                                <div id='bodyContent'>
                                    <b>${DETECTPHRASE["Genauigkeit"]}:</b> ${strAccuracy} ${accuracyEinheit}${markerHinweis}<br /><br />
                                    <b>${DETECTPHRASE["Land"]}:</b> ${iptcity.responseJSON.country_name}${continent}&nbsp;${imgFlag}<br />
                                    <b>${DETECTPHRASE["Region"]}:</b> ${iptcity.responseJSON.region}<br />
                                    <b>${DETECTPHRASE["Ort"]}:</b> ${city}<br /><br />
                                    <b>${DETECTPHRASE["Breitengrad"]}:</b> ${latitude}<br />
                                    <b>${DETECTPHRASE["Längengrad"]}:</b> ${longitude}<br />
                                </div>
                            </div>`;

                        if(protokoll === "ipv4") {
                            pinA = detectGeo_Map.updateOpenStreetMaps(
                                "pinA",
                                iptcity.responseJSON.latitude, iptcity.responseJSON.longitude,
                                accuracy, pinAstyle.strokeColor,
                                pinAstyle.fillColor, pinAstyle.icon, content
                            );
                        } else {
                            pinB = detectGeo_Map.updateOpenStreetMaps(
                                "pinB",
                                iptcity.responseJSON.latitude, iptcity.responseJSON.longitude,
                                accuracy, pinBstyle.strokeColor,
                                pinBstyle.fillColor, pinBstyle.icon, content
                            );
                        }
                    }
                } else if (iptcity.responseJSON.status === "AUTH") {
                    console.warn("Fehler im GeoCity-Modul (Auth failed)");
                    $("#" + protokoll + "geocountry").text(DETECTPHRASE["Ermittlung des Standortes ist fehlgeschlagen"]);
                    $("#" + protokoll + "georegion").text("-");
                    $("#" + protokoll + "geocity").text("-");
                    $("#" + protokoll + "geotimezone").text("-");
                    $("#" + protokoll + "geolatitude").text("-");
                    $("#" + protokoll + "geolongitude").text("-");
                } else {
                    console.warn("Fehler im GeoCity-Modul (Unknown Status)");
                    $("#" + protokoll + "geocountry").text(DETECTPHRASE["Ermittlung des Standortes ist fehlgeschlagen"]);
                    $("#" + protokoll + "georegion").text("-");
                    $("#" + protokoll + "geocity").text("-");
                    $("#" + protokoll + "geotimezone").text("-");
                    $("#" + protokoll + "geolatitude").text("-");
                    $("#" + protokoll + "geolongitude").text("-");
                }
            }).fail(function () {
                console.warn("Fehler im GeoCity-Modul (AJAX failed)");
                $("#" + protokoll + "geocountry").text(DETECTPHRASE["Ermittlung des Standortes ist fehlgeschlagen"]);
                $("#" + protokoll + "georegion").text("-");
                $("#" + protokoll + "geocity").text("-");
                $("#" + protokoll + "geotimezone").text("-");
                $("#" + protokoll + "geolatitude").text("-");
                $("#" + protokoll + "geolongitude").text("-");
            });
        } catch (err) {
            console.warn(err);
            $("#" + protokoll + "geocountry").text(DETECTPHRASE["Ermittlung des Standortes ist fehlgeschlagen"]);
            $("#" + protokoll + "georegion").text("-");
            $("#" + protokoll + "geocity").text("-");
            $("#" + protokoll + "geotimezone").text("-");
            $("#" + protokoll + "geolatitude").text("-");
            $("#" + protokoll + "geolongitude").text("-");
        }
    }

    /**
     * Hilfsfunktion: Umwandlung von Grad-Dezimal in Grad-Bogenmaß
     * Setze pinC Marker zurück!
     * @param koordinate
     * @returns
     */
    private static convertDecToBogenmass(koordinate:number):string {
        if(!this.isNumeric((koordinate)))
            return koordinate.toString();

        let output:GeoBogengrad = { grad: 0, minuten: 0, sekunden: 0 };
        output.grad = Math.floor(koordinate);
        output.minuten = Math.floor((koordinate - output.grad) * 60);
        output.sekunden = Math.round(((((koordinate - output.grad) * 60 - output.minuten) * 60) * 100) / 100);

        return `${output.grad.toString()}&#176; ${output.minuten.toString()}' ${output.sekunden.toString()}&quot;`;
    }

    /**
     * Ist Wert numeric oder string
     * @param n
     */
    private static isNumeric(n:any) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
}
